import { render } from "./TicketComponent.vue?vue&type=template&id=a986b246"
import script from "./TicketComponent.vue?vue&type=script&lang=js"
export * from "./TicketComponent.vue?vue&type=script&lang=js"

import "./TicketComponent.vue?vue&type=style&index=0&id=a986b246&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__